import React, { useEffect, useState } from "react";
import Button from "../button";
import "./index.scss";

const Form = ({
  className,
  end,
  isDirty,
  onChange,
  onSubmit,
  skip,
  status,
  reset,
}) => {
  const [input, setInput] = useState("");

  useEffect(() => {
    if (isDirty) setInput("");
  }, [isDirty]);

  const handleSubmit = (event) => {
    event.preventDefault();

    if (status === "success" && reset) return reset();
    const { target = [] } = event;
    const { value } = target[0];

    if (onSubmit) onSubmit(value);
  };

  const handleChange = (e) => {
    const { target } = e;
    const { value } = target;

    setInput(value);
    if (onChange) onChange(value);
  };

  return (
    <form onSubmit={handleSubmit}>
      <textarea
        className={`input${className ? ` ${className}` : ""}`}
        onChange={handleChange}
        placeholder={"translate..."}
        spellCheck={false}
        value={input}
        autoComplete={"off"}
        autoCorrect={"off"}
        id="answer"
      />
      <div className="button-container">
        <Button onClick={onSubmit} text="mark" />
        <Button onClick={skip} text="skip" />
        <Button onClick={end} text="end" />
      </div>
    </form>
  );
};

export default Form;
